const performanceRoutes = {
  clientPerformances: {
    path: '/performance-history'
  },
  createPerformance: {
    path: '/performances/create'
  },
  createPerformanceDynamic: {
    path: '/performances/create-dynamic'
  },
  dynamicPerformance: {
    path: '/performance/dynamic'
  },
  editPerformance: {
    path: '/performances/edit/:id'
  },
  listPerformance: {
    path: '/performances/list'
  },
  performanceDashboard: {
    path: '/performances'
  },
  viewClientPerformance: {
    path: '/users/clients/:id/performance'
  }
};

export default performanceRoutes;
